(function () {
  'use strict';

  /* Script may load once per section instance; bind document listeners only once. */
  if (window.__navDirectLinkBound) return;
  window.__navDirectLinkBound = true;

  var ACCORDION_FALLBACK_MS = 550;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function clearDisclosureTimer(panel) {
    if (!panel) return;
    if (panel._disclosureTimer) {
      window.clearTimeout(panel._disclosureTimer);
      panel._disclosureTimer = null;
    }
    if (panel._disclosureHandler) {
      panel.removeEventListener('transitionend', panel._disclosureHandler);
      panel._disclosureHandler = null;
    }
  }

  function setDisclosure(panel, open, instant) {
    if (!panel) return;
    clearDisclosureTimer(panel);
    instant = instant || prefersReducedMotion();

    if (open) {
      panel.hidden = false;
      if (instant) {
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      void panel.offsetHeight;
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      return;
    }

    panel.classList.remove('is-open');
    if (instant || panel.hidden) {
      panel.hidden = true;
      return;
    }

    function finish(event) {
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'grid-template-rows') {
        return;
      }
      clearDisclosureTimer(panel);
      panel.hidden = true;
    }

    panel._disclosureHandler = finish;
    panel.addEventListener('transitionend', finish);
    panel._disclosureTimer = window.setTimeout(finish, ACCORDION_FALLBACK_MS);
  }

  function setToggleLabel(toggle, open) {
    if (!toggle) return;
    var label = toggle.querySelector('.visually-hidden');
    if (!label) return;
    var expand = toggle.getAttribute('data-label-expand');
    var collapse = toggle.getAttribute('data-label-collapse');
    if (open && collapse) {
      label.textContent = collapse;
    } else if (!open && expand) {
      label.textContent = expand;
    }
  }

  function setRowOpen(item, open) {
    if (!item) return;
    var toggle = item.querySelector('[data-accordion-toggle]');
    if (open) {
      item.classList.add('is-open');
    } else {
      item.classList.remove('is-open');
    }
    setToggleLabel(toggle, open);
  }

  function closeAllAccordions(root, instant) {
    if (!root) return;
    var toggles = root.querySelectorAll('[data-accordion-toggle]');
    var panels = root.querySelectorAll('[data-accordion-panel]');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      setRowOpen(toggle.closest('[data-nav-direct-link-item]'), false);
    });
    panels.forEach(function (panel) {
      setDisclosure(panel, false, instant);
    });
  }

  function openPanel(root, toggle, instant) {
    if (!root || !toggle) return;
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    closeAllAccordions(root, instant);
    toggle.setAttribute('aria-expanded', 'true');
    setRowOpen(toggle.closest('[data-nav-direct-link-item]'), true);
    setDisclosure(panel, true, instant);
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-direct-link] [data-accordion-toggle]');
    if (!toggle) return;

    var root = toggle.closest('[data-nav-direct-link]');
    var panelId = toggle.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!root || !panel) return;

    var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    closeAllAccordions(root, false);

    if (willOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      setRowOpen(toggle.closest('[data-nav-direct-link-item]'), true);
      setDisclosure(panel, true, false);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest
      ? event.target.closest('[data-nav-direct-link-panel-item]')
      : null;
    if (!item) return;
    var root = item.closest('[data-nav-direct-link]');
    var toggle = item.querySelector('[data-accordion-toggle]');
    if (root && toggle) openPanel(root, toggle, true);
  });
})();
